import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';

const pages = [];
export default function TemporaryDrawer(props) {
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={props.toggleDrawer(anchor, false)}
      onKeyDown={props.toggleDrawer(anchor, false)}
      style={{backgroundColor:'',height:'100%'}}
    >
      <List>
        {pages.map((page) => (
          <div style={{ marginLeft: 'auto', marginTop: '60px', width: '80%',}}>
                <a href={page.href}
                  key={page.head}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                  style={{marginLeft:40,color:'black',textDecoration:'none'}}
                >
                  <span className="lato-font">{page.head}</span>
                </a>
          </div>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
        <React.Fragment key={'left'}>
          <Drawer
            anchor={'left'}
            open={props.open}
            onClose={props.toggleDrawer('left', false)}
          >
            {list('left')}
          </Drawer>
        </React.Fragment>
    </div>
  );
}
